import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { Route } from '../../config/router'
import { useConsumerHasCreditFacility } from '../../state'
import { useFlag, LaunchDarklyFlags } from '../useFlag'

export const useGatePayMonthlyPage = (): void => {
  const router = useRouter()
  const isPayMonthlyEnabled = useFlag(LaunchDarklyFlags.ConsumerPortalPayMonthlyEnabled, false)
  const hasCreditFacility = useConsumerHasCreditFacility()
  const isPayMonthlyPageAccessible = isPayMonthlyEnabled && hasCreditFacility
  useEffect(() => {
    // User has navigated to Pay Monthly page when the navigation item is hidden
    if (!isPayMonthlyPageAccessible) {
      router.push(Route.HOME)
    }
  }, [isPayMonthlyPageAccessible, router])
}
